import 'client-only'
import {injectable} from 'inversify'
import type {
  ISessionResponseProcessor,
  SessionProcessInput,
  SessionProcessResult,
} from '@/src/ports/services/session-response-processor'

@injectable()
export class ClientSessionResponseProcessor implements ISessionResponseProcessor {
  async process(input: SessionProcessInput): Promise<SessionProcessResult> {
    return {service: input.data}
  }
}
